import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const UserRolesDropdown = (props) => {
    const { onChange, value, multiple, classN, req, id } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getUserRoles = async () => {
        const res = await postMethod("/user-roles");
        if (checkServerData(res)) setList(res.data.list);
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getUserRoles();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : ""}>
                <Form.Label>
                    {t(`users.userRole${multiple ? "s" : ""}`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown
                        placeholder={multiple ? t("chooseMany") : t("choose")}
                        fluid
                        multiple={multiple}
                        selection
                        options={list}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                    />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default UserRolesDropdown;
